import agent from './agent';
import config from '../config.json';
import CoreBase from './engines/CoreBase';

const baseUrl = config.baseUrl;

export default class ServiceBase extends CoreBase {
    // postFlushCommand = () => {
    //     const d = {};
    //     return this.postSystemCommand('PostFlushRequest', d);
    // };

    /**
     *
     * @param {*} dto
     * @returns
     */
    postDebugSwitch = (service, dto) => {
        const url = `${baseUrl}/${service}/debug/switch`;
        return agent.post(url, dto);
    };

    /**
     *
     * @param {string} service the servic name like portal, bitvavo, tickerhistory
     * @param {string} cmd the command name like OnRepairRequested
     * @param {any} d data object holding command parameter info
     * @returns promise
     */
    request = (service, cmd, d) => {
        const json = JSON.stringify(d);
        const data = this.createSystemEvent(cmd, null, json, null);
        return this.postSystemCommand2(service, data);
    };

    /**
     * execute domain event on service
     *
     * @param {*} service
     * @param {*} cmd
     * @param {*} target
     * @param {*} d
     * @returns
     */
    executeDomainEvent = (service, target, cmd, d) => {
        const json = JSON.stringify(d);
        const data = this.createSystemEvent(cmd, target, json, null);
        return this.postSystemCommand2(service, data);
    };

    /**
     * obsolete
     *
     * @param {string} service , service name
     * @param {string} request, Command Request
     * @param {any} data, request data
     * @returns
     */
    postSystemCommand = (service, request, data) => {
        const p = {
            t: request,
            o: JSON.stringify(data),
        };

        const url = `${baseUrl}/api/v1/${service}/systemCommand`;
        return agent.post(url, p);
    };

    /**
     *
     *
     * @param {string} service , service name
     * @param {string} request, Command Request
     * @param {any} data, request data
     * @returns
     */
    postSystemCommand2 = (service, p) => {
        const url = `${baseUrl}/api/v1/${service}/systemCommand`;
        return agent.post(url, p);
    };

    /**
     *
     * @param {string} o th operation name
     * @param {string} t target service if needed
     * @param {string} d json serialized parameter data
     * @param {number} sid the targeted sid if applyable
     */
    createSystemEvent = (o, t, d, sid) => {
        const r = {
            t: t,
            e: 'PostSystemEventRequest',
            o: o,
        };

        if (d) {
            r.d = d;
        }

        if (sid) {
            r.d = `${sid}`;
        }

        return r;
    };
}
